// src/constants/flatRooms.js
// New file: Centralizes bedroom & bathroom count options.

export const bedroomsOptions = [
  { value: '1', ar: '١', en: '1' },
  { value: '2', ar: '٢', en: '2' },
  { value: '3', ar: '٣', en: '3' },
  { value: '4', ar: '٤', en: '4' },
  { value: '+4', ar: 'أكثر من ٤', en: '+4' },
];

export const bathroomsOptions = [
  { value: '1', ar: '١', en: '1' },
  { value: '2', ar: '٢', en: '2' },
  { value: '3', ar: '٣', en: '3' },
  { value: '+3', ar: 'أكثر من ٣', en: '+3' },
];